import React from 'react';

import { ICL, TaskKeysType, TaskWithLinkType, WorkType } from '../../../shared/types';
import StudentTaskWrapper from '../StudentTaskWrapper';

interface StudentTaskWithLinkProps extends TaskWithLinkType {
  icl: ICL | null;
  handleChangeTaskByKey: (id: string, key: TaskKeysType, value: string | string[] | boolean) => void;
  saveTaskAnswer: (id: string) => Promise<void>;
  iclId: ICL['id'] | null;
  hw?: boolean;
  preview?: boolean;
  studentName?: string;
  index: number;
  points: number;
  workTaskType?: WorkType;
}

export default function StudentTaskWithLink({
  icl,
  id,
  text,
  subText,
  url,
  answer,
  hasAnswer,
  hasStar,
  checkedAt,
  handleChangeTaskByKey,
  hasPhoto,
  answersPhotos,
  completedAt,
  saveTaskAnswer,
  deadline,
  audioUrl,
  videoUrl,
  taskPhotos,
  editedAnswerPhotos,
  hw,
  pdfUrl,
  wordUrl,
  studentPdfUrl,
  studentWordUrl,
  preview,
  studentName,
  index,
  points,
  workTaskType,
  teacherPoints,
}: StudentTaskWithLinkProps) {
  return (
    <StudentTaskWrapper
      icl={icl}
      taskText={text}
      subText={subText}
      link={url}
      completedAt={completedAt}
      answersPhotos={answersPhotos}
      id={id}
      handleChangeTaskByKey={handleChangeTaskByKey}
      checkedAt={checkedAt}
      hasPhoto={hasPhoto}
      saveTaskAnswer={saveTaskAnswer}
      deadline={deadline}
      audioUrl={audioUrl}
      answer={answer}
      hasAnswer={hasAnswer}
      hasStar={hasStar}
      videoUrl={videoUrl}
      taskPhotos={taskPhotos}
      editedAnswerPhotos={editedAnswerPhotos}
      hw={hw}
      pdfUrl={pdfUrl}
      wordUrl={wordUrl}
      studentPdfUrl={studentPdfUrl}
      studentWordUrl={studentWordUrl}
      preview={preview}
      studentName={studentName}
      index={index}
      points={points}
      workTaskType={workTaskType}
      teacherPoints={teacherPoints}
    >
      <></>
    </StudentTaskWrapper>
  );
}
